/*
Jira: https://mch-applicationservices.atlassian.net/browse/AB-1259
Figma: https://www.figma.com/file/4W9eSTn0I9bZuE6mZ4pT4C/branch/tgRCzOzQNanNeN7Jr4DZUW/Article-Layout?node-id=12618%3A310723&t=bJMHyoEohBhGnHx1-0
Storybook: https://storybook-uikit-dev.azurewebsites.net/?path=/story/components-structure-media-media-caption--media-caption
*/
import React, { FC, useContext } from 'react'
import { Container } from '@mch-group/uikit-components'
import IEMImageMosaic from './types'
import { useEditorialModule } from '@hooks'
import classNames from 'classnames'
import {
  EMImageMosaicTwoImages,
  EMImageMosaicFourImages,
  EMImageMosaicThreeImagesDynamic,
  EMImageMosaicThreeImagesStructured
} from '@components'
import { PageContext } from '@providers/PageContext'

const EMImageMosaic: FC<IEMImageMosaic> = ({ emim_image_displayed_format, ...props }) => {
  const { containedLayout } = useEditorialModule()
  const { page: { siteLanguage } } = useContext(PageContext)

  return (
    <section
      id={props.id}
      className={classNames('em-image-mosaic', siteLanguage === 'zh_CN' ?
        'mb-7 mb-md-8' : 'mb-9 mb-md-12')}
    >
      {containedLayout(emim_image_displayed_format) ? (
        <Container className='px-5 px-lg-8 px-md-7 mt-0'>
          {emim_image_displayed_format === '2 images' && <EMImageMosaicTwoImages {...props} />}
          {emim_image_displayed_format === '3 images - dynamic' && <EMImageMosaicThreeImagesDynamic {...props} />}
          {emim_image_displayed_format === '4 images' && <EMImageMosaicFourImages {...props} />}
        </Container>
      ) : (
        <EMImageMosaicThreeImagesStructured {...props} />
      )}
    </section>
  )
}

export default EMImageMosaic
